module.exports = __webpack_public_path__ + "images/corners/Oval.4ae33009bd1bece838d2e3fa212d81fd.jpg";